import { render, staticRenderFns } from "./DashboardElementSummary.vue?vue&type=template&id=60e37690&scoped=true&"
import script from "./DashboardElementSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardElementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e37690",
  null
  
)

export default component.exports